var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c("v-spacer"),
      _vm._v(" "),
      _c(
        "v-col",
        { attrs: { cols: "8" } },
        [
          _c(
            "v-card",
            { staticClass: "bat", attrs: { outlined: "" } },
            [
              _c("div", { attrs: { id: "sponsors" } }),
              _vm._v(" "),
              _c("div", { attrs: { id: "modals" } }),
              _vm._v(" "),
              _vm.consentAdvertiser
                ? _c(
                    "div",
                    { staticClass: "consent-preview" },
                    [
                      _vm._l(_vm.steps, function (step) {
                        return _c(
                          "v-btn",
                          {
                            key: step.channels,
                            staticClass: "bat-display-sponsoring-button mr-2",
                            attrs: {
                              disabled: "ready" !== _vm.consentPopupState,
                              loading: "loading" === _vm.consentPopupState,
                              "data-optin-brand-advertisers-modal": "",
                              "data-consent-channels": step.channels,
                              "data-consent-display": step.display,
                              "data-consent-title": step.title,
                            },
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(step.label) + "\n        "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "consent-preview__hint" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("campaigns.sponsoring.bat.steps_hint")
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      "failed" === _vm.consentPopupState
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2 mb-0",
                              attrs: { dense: "", type: "error" },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "campaigns.sponsoring.bat.popup_unavailable"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm.hasAd
                ? _c(
                    "v-alert",
                    { staticClass: "ma-2", attrs: { dense: "", type: "info" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "campaigns.sponsoring.bat.no_advertiser_card"
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-spacer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }